import type { OwnProps, StateProps } from 'components/common-form/sidePanel/status/error/Error.connect';
import type { IntlKey } from 'locales';
import { connect } from 'react-redux';
import { addonSelector } from 'state/selectors';
import type { AppState } from 'state/state.model';

const defaultTechnicalErrorKey: IntlKey = 'quote.errorMessages.TechnicalError';

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const technicalError = addonSelector.getTechnicalErrors(state, tabId);
  const tradeInfos = addonSelector.getTradeInfo(state, tabId);

  if (!technicalError) {
    return {
      message: defaultTechnicalErrorKey,
    };
  }
  if (tradeInfos?.tradeAuthStatus === 'Timeout') {
    return {
      message: 'quote.errorMessages.tradeAuthorizationTimeout',
    };
  }

  return {
    message: technicalError.message,
    values: technicalError.values,
  };
};

export const connectError = connect(mapStateToProps);
